import { LOGIN } from 'constants/routes';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import useClearSession from 'hooks/useClearSession';

export const useHandleAutoLoginError = (isError) => {
  const navigate = useNavigate();
  const clearSession = useClearSession();

  useEffect(() => {
    if (isError) {
      clearSession();
      navigate(LOGIN);
    }
  }, [isError, navigate, clearSession]);
};
